require('./bootstrap');

/*
* Select 2
* https://select2.org/
*/
require('select2');

/*
* Toastr
* https://github.com/CodeSeven/toastr
* https://codeseven.github.io/toastr/
*/
window.toastr = require("toastr");

/*
* Datepicker
* https://github.com/flatpickr/flatpickr
* https://flatpickr.js.org/
*/
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";

/*
* CKEditor 5
* https://ckeditor.com/docs/ckeditor5/latest/index.html
*/
window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');

// Custom js from BlueMouse GmbH
require('./main');